import { COLORS, TYPE } from './tokens'
import SectionLabel from './SectionLabel'

// Sticky right rail with three blocks. Verification checkboxes are visual
// state only in Phase 2a — persistence + Verify & Sign Off button wire-up
// arrive in Phase 3. Chat button is a stub — the drawer arrives in Phase 4.
function VerificationBlock({ findings, checkedIds, onToggle }) {
  const highSeverity = (findings || []).filter(f =>
    f.severity === 'high' && f.finding_type === 'gap' && f.confidence_tier !== 'suppressed'
  )
  const allChecked = highSeverity.length > 0 && highSeverity.every(f => checkedIds.has(f.id))
  return (
    <div style={{ paddingBottom: '32px', borderBottom: `1px solid ${COLORS.hairline}` }}>
      <SectionLabel>Verification</SectionLabel>
      {highSeverity.length === 0 ? (
        <p style={{ ...TYPE.supporting, color: COLORS.mutedText }}>
          No high-severity findings require acknowledgment.
        </p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 16px' }}>
          {highSeverity.map(f => (
            <li key={f.id} style={{ display: 'flex', gap: '10px', padding: '8px 0' }}>
              <input
                type="checkbox"
                checked={checkedIds.has(f.id)}
                onChange={() => onToggle(f.id)}
                style={{ marginTop: '3px', accentColor: COLORS.accent }}
              />
              <label style={{ ...TYPE.supporting, color: COLORS.bodyText }}>
                Acknowledge: {f.title}
              </label>
            </li>
          ))}
        </ul>
      )}
      <button
        disabled={!allChecked}
        style={{
          ...TYPE.supporting,
          width: '100%',
          padding: '10px 16px',
          background: allChecked ? COLORS.accent : COLORS.hairline,
          color: allChecked ? COLORS.retentionBg : COLORS.mutedText,
          border: 'none',
          cursor: allChecked ? 'not-allowed' : 'not-allowed'
        }}
        title="Wire-up in Phase 3"
      >
        Verify and Sign Off (Phase 3)
      </button>
    </div>
  )
}

function SourceDocumentsBlock({ documents }) {
  return (
    <div style={{ padding: '32px 0', borderBottom: `1px solid ${COLORS.hairline}` }}>
      <SectionLabel>Source documents</SectionLabel>
      {(documents || []).length === 0 ? (
        <p style={{ ...TYPE.supporting, color: COLORS.mutedText }}>
          No source PDFs linked to this review.
        </p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {documents.map(d => (
            <li key={d.id} style={{ padding: '6px 0' }}>
              <div style={{ ...TYPE.supporting, color: COLORS.bodyText }}>
                {d.file_name || d.description || d.id}
              </div>
              <div style={{ ...TYPE.smallCaps, color: COLORS.mutedText }}>
                Cyber Insurance · Document Vault
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

function ChatBlock() {
  return (
    <div style={{ paddingTop: '32px' }}>
      <SectionLabel>Specialist chat</SectionLabel>
      <p style={{ ...TYPE.supporting, color: COLORS.mutedText, marginBottom: '12px' }}>
        Ask the Specialist about anything in this review. Every response cites the policy text.
      </p>
      <button
        disabled
        style={{
          ...TYPE.supporting,
          padding: '8px 14px',
          background: 'transparent',
          color: COLORS.mutedText,
          border: `1px solid ${COLORS.hairline}`,
          cursor: 'not-allowed'
        }}
        title="Drawer arrives in Phase 4"
      >
        Open Chat (Phase 4)
      </button>
    </div>
  )
}

export default function RightRail({ findings, sourceDocuments, checkedIds, onToggle, verifyPanel, actions }) {
  return (
    <aside style={{
      position: 'sticky', top: '32px',
      width: '280px',
      alignSelf: 'flex-start'
    }}>
      {verifyPanel || <VerificationBlock findings={findings} checkedIds={checkedIds} onToggle={onToggle} />}
      <SourceDocumentsBlock documents={sourceDocuments} />
      <ChatBlock />
      {actions && (
        <div style={{ paddingTop: '24px', borderTop: `1px solid ${COLORS.hairline}`, marginTop: '24px' }}>
          <div style={{ ...TYPE.smallCaps, color: COLORS.mutedText, marginBottom: '10px' }}>Actions</div>
          {actions}
        </div>
      )}
    </aside>
  )
}
